import React from 'react';
import ContentLoader from "react-content-loader" 

const NewsList = ({news, loading}) => {
    
    return (
        <>
            {
                loading ? (
                    
                        Array(3).fill(1).map((i, index) => (
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={index}>
                                <ContentLoader 
                                    speed={2}
                                    width={390}
                                    height={475}
                                    viewBox="0 0 390 475"
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                >
                                    <rect x="0" y="0" rx="2" ry="2" width="400" height="400" />
                                    <rect x="0" y="410" rx="2" ry="2" width="400" height="20" />
                                    <rect x="0" y="440" rx="2" ry="2" width="150" height="20" />
                                </ContentLoader>
                            </div>
                        ))
                    
                ) : (
                    news.map((value , i ) => (
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                                <div className="blog blog-style--1">
                                    <div className="thumbnail">
                                        <a href={`/news/${value.id}`}>
                                            <img className="w-100" src={`https://eevs-almuni.s3-ap-southeast-2.amazonaws.com/${value.thumbnail}`} alt={value.title}/>
                                        </a>
                                    </div>
                                    <div className="content">
                                        <h3 className="text-white">{value.points}</h3> 
                                        <h4 className="title"><a href={`/news/${value.id}`}>{value.title}</a></h4>
                                        <div className="blog-btn">
                                            <a className="rn-btn text-white" href={`/news/${value.id}`}>Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                )
            }
            
        </>
    );
}

export default NewsList;